export default {
  methods: {
    async slipTotalMoney(slip, expandColumn) {
      return formatMoney(
        // !(slip.contractQty >= 2)
        !slip.contractQty ? slip.discountedValue : slip[expandColumn].total
      );
    },
    async slipTotal(slip, expandColumn) {
      return formatMoney(
        // !(slip.contractQty >= 2)
        !slip.contractQty ? slip.discountedValue : slip[expandColumn].total
      );
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/slip.js